<h5 class="text-success">Grille d'achat des services</h5>
<div class="d-flex justify-content-center">
  <table class="table grille-service">
    <thead>
      <tr>
        <th>Nature du service</th>
        <th>Nombre de crédits</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let tarif of tarifs">
        <td>{{ tarif.natureService }}</td>
        <td class="nombre">{{ tarif.nbreCredit }} crédits</td>
      </tr>
    </tbody>
  </table>
</div>
